export const useIsESCDA2025Enabled = () => {
  const isESCDA2025Enabled = true;
  const ESCDA_BANNER_HEIGHT = 50.58;
  return {
    ESCDA_BANNER_HEIGHT,
    isESCDA2025Enabled,
  };
};
